module.exports = __webpack_public_path__ + "img/1536162041.c5d419eb.jpg";